import { colorConfig, colorStaticConfig } from '@themes/config'

const colors = {
  ...colorConfig,
  ...colorStaticConfig,
} as const

export default colors
